(() => {
  const SERVICE_LABELS = {
    maintenance_1000: "Mantención 1.000 km",
    preventive_maintenance: "Mantención preventiva",
    corrective_diagnosis: "Diagnóstico correctivo",
    key_copy: "Copia de llave",
  };

  const MAINTENANCE_SERVICES = new Set([
    "maintenance_1000",
    "preventive_maintenance",
  ]);

  const AVAILABILITY_CONNECTION_ERROR =
    "No pudimos consultar los horarios. Revisa la conexión e intenta nuevamente.";

  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const phonePattern = /^\+?[0-9\s()-]{8,20}$/;
  const vehicleIdentifierPattern = /^[A-Z0-9]+$/;
  const vehicleIdentifierMinLength = 3;
  const vehicleIdentifierMaxLength = 20;
  const vehicleIdentifierMessage =
    "Revisa la patente o identificador de la moto. Escríbelo sin espacios, puntos ni guiones.";

  const normalizeBaseUrl = (value) => value.replace(/\/+$/, "");
  const getField = (form, name) => form.elements.namedItem(name);
  const normalizeVehicleIdentifier = (value) =>
    value.trim().toUpperCase().replace(/[\s.-]+/g, "");
  const isValidVehicleIdentifier = (value) =>
    value.length >= vehicleIdentifierMinLength &&
    value.length <= vehicleIdentifierMaxLength &&
    vehicleIdentifierPattern.test(value);

  const formatDate = (isoDate) =>
    new Intl.DateTimeFormat("es-CL", {
      dateStyle: "long",
    }).format(new Date(isoDate));

  const formatTime = (isoDate) =>
    new Intl.DateTimeFormat("es-CL", {
      hour: "2-digit",
      minute: "2-digit",
    }).format(new Date(isoDate));

  const getServiceType = (form) => getField(form, "service_type").value;

  const setButtonBusy = (button, isBusy, busyText) => {
    if (!button) return;

    const label = button.querySelector("[data-button-text], [data-submit-text]") || button;

    if (!button.dataset.defaultText) {
      button.dataset.defaultText = label.textContent.trim();
    }

    label.textContent = isBusy ? busyText : button.dataset.defaultText;
    button.disabled = isBusy || button.dataset.locked === "true";
    button.classList.toggle("is-loading", isBusy);
  };

  const setSubmitBusy = (container, isBusy) => {
    const submitButton = container.querySelector("[data-gogoro-submit]");
    container.dataset.submitting = isBusy ? "true" : "false";
    setButtonBusy(submitButton, isBusy, "Confirmando...");
  };

  const showError = (container, key, message) => {
    const error = container.querySelector(`[data-error-for="${key}"]`);
    if (!error) return;

    error.textContent = message;
    error.hidden = false;
  };

  const clearErrors = (container) => {
    container.querySelectorAll("[data-error-for], [data-gogoro-status]").forEach((error) => {
      error.textContent = "";
      error.hidden = true;
    });

    container.querySelectorAll(".is-invalid").forEach((field) => {
      field.classList.remove("is-invalid");
    });
  };

  const showGlobalStatus = (container, message, type = "error") => {
    const status = container.querySelector("[data-gogoro-status]");
    if (!status) return;

    status.textContent = message;
    status.dataset.status = type;
    status.hidden = false;
  };

  const markInvalid = (field) => {
    if (!field) return;

    const wrapper = field.closest(".gogoro-booking__field") || field;
    wrapper.classList.add("is-invalid");
  };

  const setService = (container, form, value) => {
    getField(form, "service_type").value = value;

    container.querySelectorAll("[data-service-card]").forEach((card) => {
      const isSelected = card.dataset.value === value;
      card.classList.toggle("is-selected", isSelected);
      card.setAttribute("aria-checked", String(isSelected));
      card.tabIndex = isSelected ? 0 : -1;
    });

    const commentsField = container.querySelector("[data-comments-field]");
    const mileageField = container.querySelector("[data-mileage-field]");
    const comments = getField(form, "comments");
    const mileage = getField(form, "mileage");

    comments.required = value === "corrective_diagnosis";
    mileage.required = MAINTENANCE_SERVICES.has(value);
    commentsField.classList.toggle("is-emphasized", comments.required);
    mileageField.classList.toggle("is-emphasized", mileage.required);

    resetSlots(container, "Consulta horas disponibles");
    updateSubmitState(container, form);
  };

  const setAvailabilityState = (container, state, message) => {
    const slotInput = container.querySelector("[data-gogoro-slot-input]");
    const slots = container.querySelector("[data-gogoro-slots]");
    if (!slotInput || !slots) return;

    slotInput.value = "";
    slots.dataset.availabilityState = state;

    const messageNode = document.createElement("p");
    messageNode.className = "gogoro-booking__slot-message";
    messageNode.textContent = message;
    slots.replaceChildren(messageNode);
  };

  const resetSlots = (container, message = "Selecciona servicio, modelo y fecha para consultar.") => {
    setAvailabilityState(container, "initial", message);
  };

  const readPayload = (form) => {
    const mileage = getField(form, "mileage").value.trim();
    const plateField = getField(form, "plate");
    const plate = normalizeVehicleIdentifier(plateField.value);
    plateField.value = plate;

    return {
      service_type: getField(form, "service_type").value,
      model: getField(form, "model").value,
      year: Number(getField(form, "year").value),
      plate,
      mileage: mileage === "" ? undefined : Number(mileage),
      first_name: getField(form, "first_name").value.trim(),
      last_name: getField(form, "last_name").value.trim(),
      rut: getField(form, "rut").value.trim(),
      email: getField(form, "email").value.trim(),
      phone: getField(form, "phone").value.trim(),
      date: getField(form, "date").value,
      start_at: getField(form, "start_at").value,
      comments: getField(form, "comments").value.trim(),
      privacy_consent: getField(form, "privacy_consent").checked,
    };
  };

  const validateAvailabilityInputs = (container, form) => {
    const serviceType = getServiceType(form);
    const model = getField(form, "model");
    const date = getField(form, "date");
    let isValid = true;

    if (!serviceType) {
      showError(container, "service_type", "Selecciona un servicio.");
      isValid = false;
    }

    if (!model.value) {
      markInvalid(model);
      showError(container, "vehicle", "Selecciona el modelo de tu Gogoro.");
      isValid = false;
    }

    if (!date.value) {
      markInvalid(date);
      showError(container, "schedule", "Selecciona una fecha para consultar horarios.");
      isValid = false;
    }

    return isValid;
  };

  const validateBooking = (container, form, payload) => {
    let isValid = true;

    const fail = (key, message, field) => {
      showError(container, key, message);
      markInvalid(field);
      isValid = false;
    };

    if (!payload.service_type) {
      fail("service_type", "Selecciona un servicio.");
    }

    if (!payload.model) {
      fail("vehicle", "Selecciona el modelo de tu Gogoro.", getField(form, "model"));
    }

    if (!payload.year || Number.isNaN(payload.year)) {
      fail("vehicle", "Ingresa el año de tu moto.", getField(form, "year"));
    }

    if (!payload.plate) {
      fail("vehicle", "La patente o identificador de la moto es obligatorio.", getField(form, "plate"));
    } else if (!isValidVehicleIdentifier(payload.plate)) {
      fail("vehicle", vehicleIdentifierMessage, getField(form, "plate"));
    }

    if (payload.service_type === "corrective_diagnosis" && !payload.comments) {
      fail("vehicle", "Para diagnóstico correctivo, cuéntanos qué quieres revisar.", getField(form, "comments"));
    }

    if (MAINTENANCE_SERVICES.has(payload.service_type) && payload.mileage === undefined) {
      fail("vehicle", "Para mantenciones, ingresa el kilometraje.", getField(form, "mileage"));
    }

    if (!payload.date) {
      fail("schedule", "Selecciona una fecha.", getField(form, "date"));
    }

    if (!payload.start_at) {
      fail("schedule", "Selecciona una hora disponible.");
    }

    if (!payload.first_name || !payload.last_name || !payload.rut) {
      fail("contact", "Completa nombre, apellido y RUT.");
    }

    if (!emailPattern.test(payload.email)) {
      fail("contact", "Ingresa un email válido.", getField(form, "email"));
    }

    if (!phonePattern.test(payload.phone)) {
      fail("contact", "Ingresa un teléfono válido.", getField(form, "phone"));
    }

    if (!payload.privacy_consent) {
      fail("consent", "Debes aceptar el tratamiento de tus datos.", getField(form, "privacy_consent"));
      showGlobalStatus(container, "Debes aceptar el tratamiento de tus datos.");
    }

    return isValid;
  };

  const hasMinimumSubmitData = (form) => {
    const payload = readPayload(form);
    const hasRequiredServiceDetail =
      (payload.service_type === "corrective_diagnosis" && payload.comments) ||
      (MAINTENANCE_SERVICES.has(payload.service_type) && payload.mileage !== undefined) ||
      (payload.service_type === "key_copy");

    return Boolean(
      payload.service_type &&
        hasRequiredServiceDetail &&
        payload.model &&
        payload.year &&
        isValidVehicleIdentifier(payload.plate) &&
        payload.first_name &&
        payload.last_name &&
        payload.rut &&
        emailPattern.test(payload.email) &&
        phonePattern.test(payload.phone) &&
        payload.date &&
        payload.start_at &&
        payload.privacy_consent,
    );
  };

  function updateSubmitState(container, form) {
    const submitButton = container.querySelector("[data-gogoro-submit]");
    const submitHint = container.querySelector("[data-gogoro-submit-hint]");
    if (!submitButton || submitButton.classList.contains("is-loading")) return;

    const enabled = hasMinimumSubmitData(form);
    const hasSlot = Boolean(getField(form, "start_at").value);

    submitButton.disabled = !enabled;
    submitButton.dataset.locked = enabled ? "false" : "true";

    if (submitHint) {
      submitHint.textContent = !hasSlot
        ? "Selecciona una fecha y hora para continuar"
        : enabled
          ? "Listo para confirmar tu reserva"
          : "Completa tus datos para confirmar";
    }
  }

  const renderSlots = (container, slots) => {
    const slotInput = container.querySelector("[data-gogoro-slot-input]");
    const slotList = container.querySelector("[data-gogoro-slots]");
    const availableSlots = slots.filter((slot) => slot.available);

    slotInput.value = "";

    if (!availableSlots.length) {
      setAvailabilityState(container, "empty", "No hay horas disponibles para esa fecha. Prueba con otro día.");
      return;
    }

    slotList.dataset.availabilityState = "available";
    slotList.innerHTML = "";

    availableSlots.forEach((slot) => {
      const button = document.createElement("button");
      button.type = "button";
      button.className = "gogoro-booking__slot";
      button.textContent = formatTime(slot.start_at);
      button.dataset.startAt = slot.start_at;
      button.dataset.endAt = slot.end_at;
      button.setAttribute("aria-pressed", "false");

      button.addEventListener("click", () => {
        slotList.querySelectorAll(".gogoro-booking__slot").forEach((item) => {
          item.classList.remove("is-selected");
          item.setAttribute("aria-pressed", "false");
        });

        button.classList.add("is-selected");
        button.setAttribute("aria-pressed", "true");
        slotInput.value = slot.start_at;
        clearErrors(container);
        updateSubmitState(container, container.querySelector("form"));
      });

      slotList.appendChild(button);
    });
  };

  const loadAvailability = async (container, form) => {
    clearErrors(container);

    if (!validateAvailabilityInputs(container, form)) {
      updateSubmitState(container, form);
      return;
    }

    const backendUrl = normalizeBaseUrl(container.dataset.backendUrl || "");
    const button = container.querySelector("[data-gogoro-load-slots]");

    setButtonBusy(button, true, "Consultando...");
    setAvailabilityState(container, "loading", "Buscando horarios disponibles...");

    try {
      const response = await fetch(`${backendUrl}/api/gogoro-service/availability`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          service_type: getServiceType(form),
          date: getField(form, "date").value,
        }),
      });

      if (!response.ok) {
        throw new Error("availability_failed");
      }

      const data = await response.json();
      renderSlots(container, data.slots || []);
    } catch (_error) {
      setAvailabilityState(container, "error", AVAILABILITY_CONNECTION_ERROR);
      showError(container, "schedule", AVAILABILITY_CONNECTION_ERROR);
    } finally {
      setButtonBusy(button, false);
      updateSubmitState(container, form);
    }
  };

  const showConfirmation = (container, form, result) => {
    const confirmation = container.querySelector("[data-gogoro-confirmation]");
    const serviceType = getServiceType(form);
    const startAt = getField(form, "start_at").value;

    confirmation.querySelector("[data-confirmation-code]").textContent = result.reservation_code;
    confirmation.querySelector("[data-confirmation-service]").textContent =
      SERVICE_LABELS[serviceType] || serviceType;
    confirmation.querySelector("[data-confirmation-date]").textContent = formatDate(startAt);
    confirmation.querySelector("[data-confirmation-time]").textContent = formatTime(startAt);

    confirmation.hidden = false;
    form.hidden = true;
    confirmation.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const createBooking = async (container, form) => {
    if (container.dataset.submitting === "true") {
      return;
    }

    clearErrors(container);

    const payload = readPayload(form);

    if (!validateBooking(container, form, payload)) {
      updateSubmitState(container, form);
      return;
    }

    const backendUrl = normalizeBaseUrl(container.dataset.backendUrl || "");
    setSubmitBusy(container, true);

    try {
      const response = await fetch(`${backendUrl}/api/gogoro-service/bookings`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(data.error || "booking_failed");
      }

      showConfirmation(container, form, data);
    } catch (error) {
      if (error instanceof Error && error.message === "invalid_vehicle_identifier") {
        showError(container, "vehicle", vehicleIdentifierMessage);
        markInvalid(getField(form, "plate"));
        showGlobalStatus(container, vehicleIdentifierMessage);
      } else {
        showGlobalStatus(container, "No pudimos crear la reserva. Revisa los datos o intenta nuevamente.");
      }
    } finally {
      setSubmitBusy(container, false);
      updateSubmitState(container, form);
    }
  };

  const initServiceCards = (container, form) => {
    const cards = Array.from(container.querySelectorAll("[data-service-card]"));

    cards.forEach((card, index) => {
      card.tabIndex = index === 0 ? 0 : -1;

      card.addEventListener("click", () => {
        clearErrors(container);
        setService(container, form, card.dataset.value);
      });

      card.addEventListener("keydown", (event) => {
        const currentIndex = cards.indexOf(card);
        let nextIndex = currentIndex;

        if (event.key === "ArrowRight" || event.key === "ArrowDown") {
          nextIndex = (currentIndex + 1) % cards.length;
        } else if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
          nextIndex = (currentIndex - 1 + cards.length) % cards.length;
        } else if (event.key === " " || event.key === "Enter") {
          event.preventDefault();
          setService(container, form, card.dataset.value);
          return;
        } else {
          return;
        }

        event.preventDefault();
        cards.forEach((item, itemIndex) => {
          item.tabIndex = itemIndex === nextIndex ? 0 : -1;
        });
        cards[nextIndex].focus();
      });
    });
  };

  const initBooking = (container) => {
    const form = container.querySelector("form");
    if (!form) return;

    initServiceCards(container, form);

    form.querySelectorAll("input, select, textarea").forEach((field) => {
      field.addEventListener("input", () => {
        if (field.name === "comments") {
          const counter = container.querySelector("[data-comments-count]");
          counter.textContent = String(field.value.length);
        }

        if (["model", "date"].includes(field.name)) {
          resetSlots(container, "Consulta horas disponibles");
        }

        clearErrors(container);
        updateSubmitState(container, form);
      });

      field.addEventListener("change", () => {
        if (["model", "date"].includes(field.name)) {
          resetSlots(container, "Consulta horas disponibles");
        }

        clearErrors(container);
        updateSubmitState(container, form);
      });
    });

    container
      .querySelector("[data-gogoro-load-slots]")
      .addEventListener("click", () => loadAvailability(container, form));

    form.addEventListener("submit", (event) => {
      event.preventDefault();
      createBooking(container, form);
    });

    updateSubmitState(container, form);
  };

  document.addEventListener("DOMContentLoaded", () => {
    document
      .querySelectorAll("[data-gogoro-service-booking]")
      .forEach(initBooking);
  });
})();
